import { FormGroup, ProcessItemContainer, ProcessItemHeader, Text } from '@ksyos/design-system';
import { useMemo } from 'react';
import type { IOsasnV1CustomControlData } from '@common/interfaces/somnology';
import { getDisplayName } from '@common/utils/getDisplayName';
import { ContactReadButtons } from '@frontend/components/elements/carePathButtons';
import { RequestAssetThumbnails } from '@frontend/components/pages/episodes/common';
import { translateKey } from '@frontend/translate';
import type { ICustomControlRequestReadProps } from '../../../interfaces';
import { getRequestFiles } from '../../../utils';
import { getTitle } from './common';

export function OsasnV1RequestRead(props: ICustomControlRequestReadProps<IOsasnV1CustomControlData>) {
    const title = useMemo(
        () => getTitle(props.process.code, props.process.name, props.request.customControlData.title),
        [props.process.code, props.process.name, props.request.customControlData.title]
    );

    return (
        <ProcessItemContainer>
            <ProcessItemHeader
                color="secondary"
                date={props.process.dateSent}
                icon="contact"
                isOpen={props.itemState.isOpen}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                processId={props.process.processId.toString()}
                title={title}
            />

            {props.request.customControlData.text && (
                <FormGroup label={translateKey('osasNotitie.noteTextLabel')}>
                    <Text fontWeight="bold">{props.request.customControlData.text}</Text>
                </FormGroup>
            )}

            {props.request.assets!.length > 0 && (
                <FormGroup label={translateKey('osasNotitie.filesLabel')}>
                    <RequestAssetThumbnails
                        assets={getRequestFiles(props.request)}
                        requestId={props.request.id}
                    />
                </FormGroup>
            )}

            {props.request.customControlData.informGeneralPractitioner !== undefined && (
                <FormGroup label={translateKey('osasNotitie.informGeneralPractitionerLabel')}>
                    <Text fontWeight="bold">
                        {props.request.customControlData.informGeneralPractitioner
                            ? translateKey('common.yes')
                            : translateKey('common.no')}
                    </Text>
                </FormGroup>
            )}

            <ContactReadButtons {...props} />
        </ProcessItemContainer>
    );
}
